module.exports = __webpack_public_path__ + "static/media/vehicle-insurance.27b54a05.png";